module.exports = __webpack_public_path__ + "static/media/measurement-current.381e09a4.svg";